import {
  DealsDepartments,
  GoldVisionProposal,
} from '@/models/GoldVision/GoldVisionDeal';

import { ActionType, getType } from 'typesafe-actions';

import * as dealsActions from './actions';

type DealsActionType = ActionType<typeof dealsActions>;

export type DealsState = {
  dealsList: {
    loading: boolean;
    data: GoldVisionProposal[];
    total_objects: number;
  };
  dealsDepartments: {
    loading: boolean;
    data: DealsDepartments[];
  };
  gvResync: {
    in_progress: boolean;
  };
};

const initialState: DealsState = {
  dealsList: {
    loading: false,
    data: [],
    total_objects: 0,
  },
  dealsDepartments: {
    loading: false,
    data: [],
  },
  gvResync: {
    in_progress: false,
  },
};

export const dealsReducer = (
  state: DealsState = initialState,
  action: DealsActionType,
): DealsState => {
  switch (action.type) {
    case getType(dealsActions.getGoldVisionOpenDeals.request):
    case getType(dealsActions.getGoldVisionClosedDeals.request):
      return {
        ...state,
        dealsList: {
          ...state.dealsList,
          loading: true,
        },
      };
    case getType(dealsActions.getDealsDepartments.request):
      return {
        ...state,
        dealsDepartments: { ...state.dealsDepartments, loading: true },
      };
    case getType(dealsActions.getGoldVisionOpenDeals.success):
    case getType(dealsActions.getGoldVisionClosedDeals.success):
      return {
        ...state,
        dealsList: {
          ...state.dealsList,
          data: action.payload.data.data.page,
          total_objects: action.payload.data.data.total_objects,
          loading: false,
        },
      };
    case getType(dealsActions.getDealsDepartments.success):
      return {
        ...state,
        dealsDepartments: {
          loading: false,
          data: action.payload.data,
        },
      };
    case getType(dealsActions.getGoldVisionOpenDeals.failure):
    case getType(dealsActions.getGoldVisionClosedDeals.failure):
      return {
        ...state,
        dealsList: {
          ...state.dealsList,
          loading: false,
        },
      };
    case getType(dealsActions.getDealsDepartments.failure):
      return {
        ...state,
        dealsDepartments: { ...state.dealsDepartments, loading: false },
      };
    case getType(dealsActions.setGoldVisionResyncInProgress):
      return {
        ...state,
        gvResync: { in_progress: action.payload },
      };

    default:
      return state;
  }
};

export default dealsReducer;
